import InputFeedback from '@ben/orion/input-feedback';
import { Collapse } from '@mantine/core';
import { memo } from 'react';

interface AirtableImportFeedbackProps {
  visible: boolean;
}

export const AirtableImportFeedback = memo(
  ({ visible }: AirtableImportFeedbackProps) => (
    <Collapse expanded={visible}>
      <InputFeedback successMessage="Imported from Airtable" />
    </Collapse>
  )
);

AirtableImportFeedback.displayName = 'AirtableImportFeedback';
